import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import './BackNext.scss'

export default function BackNext(props) {

  const { continueLabel, hideBack, disabled, loading, onBack, hide, isAflac, colSize } = props;

  const label = continueLabel || {text: 'Continue'};

  const aflac = isAflac || false;

  if (loading) {
    return <Row className="justify-content-center mt-5 mb-2"><CircularProgress /></Row>;
  }

  return (
    <Row className={hide ? 'd-none' : label === 'Contact Our Team' ? 'no-gutters-rows' : colSize ? 'justify-content-between mt-3' : ''}>
      <Col lg={colSize} className={hideBack ? 'd-none' : label === 'Contact Our Team' ? 'right-margin' : aflac === true ? 'btn-back-alignment' : ''}>
        <Form.Group>
          <Button disabled={disabled || loading} variant="outlined" color="primary" onClick={onBack} fullWidth className={aflac === true ? 'btn-back' : ''}>Back</Button>
        </Form.Group>
      </Col>
      <Col lg={colSize} className={label === 'Contact Our Team' ? 'left-margin' : aflac === true ? 'btn-next-alignment' : ''}>
        <Form.Group className={aflac ? '' : "d-flex m-0"}>
          <Button disabled={disabled || loading || props.nextDisabled} type="submit" variant="contained" color="primary" fullWidth className={label.text === 'Contact Our Team' ? 'padding' : `${aflac ? 'btn-back' : ''} submit-button ${props.className || ''}`}>{label.icon} {label.text}</Button>
        </Form.Group>
      </Col>
    </Row>
  )
}

BackNext.propTypes = {
  hide: PropTypes.bool,
  onBack: PropTypes.func,
  hideBack: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  continueLabel: PropTypes.object,
  className: PropTypes.string,
  nextDisabled: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/BackNext.js